import { privateRoutes, publicRoutes } from './routesConfig';
import RoutesRenderer from './RoutesRenderer';

const Routes = (): JSX.Element => {
  return <RoutesRenderer {...{ publicRoutes, privateRoutes }} />;
};

export default Routes;
